











































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { formatNumber } from '@/utils/helpers';
import { cloneDeep } from 'lodash';
import constants from '@/utils/constants';
@Component({
  filters: {
    formatPrice(val: any) {
      let date: any = val;
      return formatNumber(date);
    }
  }
})
export default class CartList extends Vue {
  @Prop() showFoodDetail!: boolean;
  @Prop() hideFoodDetailHandle!: Function;
  @Prop() changeCurrentFoodWithoutVariants!: Function;
  @Prop() addToCart!: Function;
  @Prop() selectedFood!: Array<any>;
  public currentFood: any = cloneDeep(this.selectedFood);
  public confirmDisabled: boolean = true;
  public totalPrice: number = 0;
  $swal: any;
  @Watch('selectedFood')
  watchSelectedFood() {
    this.currentFood = cloneDeep(this.selectedFood);
  }
  @Watch('currentFood')
  watchCurrentFood() {
    this.checkValidatiton();
  }
  @Watch('showFoodDetail')
  watchShowFoodDetail() {
    (document.getElementById('food-detail-modal') as any).scrollTop = 0;
    if (!this.showFoodDetail) {
      this.totalPrice = 0;
      this.confirmDisabled = true;
    }
  }
  checkValidatiton() {
    if (this.currentFood.variants && this.currentFood.variants.length) {
      let checkboxValidation = false;
      let radioTotal: Array<any> = [];
      let radioChecked: Array<any> = [];
      let radioPrice: number = 0;
      let checkboxPrice: number = 0;
      let checkboxChecked: Array<any> = [];
      for (let i = 0; i < this.currentFood.variants.length; i++) {
        const item = this.currentFood.variants[i];
        if (item.option === 1) {
          radioTotal.push(item);
          for (let j = 0; j < item.variant_items.length; j++) {
            const element = item.variant_items[j];
            if (element.checked) {
              radioChecked.push(element);
            }
          }
        } else {
          let min = Number(item.min);
          let checkedList: Array<any> = [];
          for (let j = 0; j < item.variant_items.length; j++) {
            const element = item.variant_items[j];
            if (element.checked) {
              checkedList.push(element);
            }
          }
          if (checkedList.length < min) {
            checkboxValidation = true;
          } else {
            checkboxValidation = false;
          }
          checkboxChecked.push(...checkedList);
        }
      }
      if (radioChecked.length) {
        radioChecked.map(item => {
          radioPrice += item.value;
        });
      }
      if (checkboxChecked.length) {
        checkboxChecked.map(item => {
          checkboxPrice += item.value;
        });
      }
      this.totalPrice =
        (radioPrice + checkboxPrice + this.currentFood.price) *
        this.currentFood.num;
      this.confirmDisabled =
        radioTotal.length !== radioChecked.length ||
        checkboxValidation ||
        !this.currentFood.num;
    } else {
      this.totalPrice = this.currentFood.price * this.currentFood.num;
      if (this.totalPrice) {
        this.confirmDisabled = false;
      }
    }
  }
  clickRadio(variantIndex, index) {
    const cloneFood = cloneDeep(this.currentFood);
    const variant_items = cloneFood.variants[variantIndex].variant_items;
    for (let i = 0; i < variant_items.length; i++) {
      const element = variant_items[i];
      element.checked = false;
    }
    variant_items[index].checked = !variant_items[index].checked;
    this.currentFood = cloneFood;
  }
  clickCheckbox(variant, variantIndex, index) {
    const cloneFood = cloneDeep(this.currentFood);
    const variant_items = cloneFood.variants[variantIndex].variant_items;
    variant_items[index].checked = !variant_items[index].checked;
    const checkedList = variant_items.filter(item => item.checked);
    if (Number(variant.max) < checkedList.length) {
      return this.$swal(
        constants.FAILED_MESSAGE,
        variant.category_name + ' must be less than max ' + variant.max,
        constants.STATUS_ERROR
      );
    }
    this.currentFood = cloneFood;
  }
  minusItem() {
    const cloneFood = cloneDeep(this.currentFood);
    if (this.currentFood.num < 1) return;
    cloneFood.num = cloneFood.num - 1;
    if (!cloneFood.num) {
      this.confirmDisabled = true;
    }
    this.currentFood = cloneFood;
    if (!cloneFood.variants || !cloneFood.variants.length) {
      this.changeCurrentFoodWithoutVariants(cloneFood);
    }
  }
  plusItem() {
    const cloneFood = cloneDeep(this.currentFood);
    cloneFood.num = cloneFood.num + 1;
    this.currentFood = cloneFood;
    if (!cloneFood.variants || !cloneFood.variants.length) {
      this.changeCurrentFoodWithoutVariants(cloneFood);
    }
  }
}
